var CreateCustomerCtrl = function ($scope, $state, customerModelService, $q, $log, VehicleService, createCustomerLoader, changeStateLoader) {
    var vm = this;
    //define internal states of the wizard
    vm.internalStates = [
        'createcustomer.manufacturer',
        'createcustomer.year',
        'createcustomer.model',
        'createcustomer.transmission',
        'createcustomer.engine',
        'createcustomer.drivetrain'
    ];
    //loader instance
    $scope.createCustomerLoader = createCustomerLoader;
    //all required data to create vehicle. It is
    //a good idea to get this information on top level
    //controller
    customerModelService.setVehicleCreationData(
        $scope.vehicleCreationData = _.defaults(customerModelService.getVehicleCreationData(),
            {
                manufacturers: [],
                models: [],
                years: [],
                engines: [],
                transmissions: [],
                driveTrains: []
            })
    );
    //save the current state index according to internal states array
    vm.currentStateIndex = 0;
    //goToState
    //
    //@param {number} index of the state to switch the view
    //
    //@description
    //Goes to the state defined by index. State name is getting
    //from internalStates variable.
    vm.goToState = function (index) {
        return $state.go(vm.internalStates[index]);
    };

    // goToOverviewState
    //
    // @param {Object} response data
    //
    // @description
    // this method leads user to the overview page if current response
    // data has a link to the vehicle request

    //TODO need to refactoring methods for reset/override vehicle models
    vm.goToOverviewState = function (responseData) {
        var deferred = $q.defer();
        if (responseData && responseData.getVehicle) {
            deferred.resolve();
        } else {
            deferred.reject();
        }
        return deferred.promise;
    };

    //getManufacturer
    //
    //@return {string} manufacturer name
    //
    //@description
    //Gets the manufacturer of the selected vehicle
    function getManufacturer() {
        var vehicle = customerModelService.getCurrentVehicle(),
            make = vehicle ? vehicle.getManufacturer() : undefined;
        return make ? make.name : appSettings.resources.Select_Manufacturer__Make;
    };
    //getYear
    //
    //@return {string} year
    //
    //@description
    //Gets the year of the selected vehicle
    function getYear() {
        var vehicle = customerModelService.getCurrentVehicle(),
            year = vehicle ? vehicle.getYear() : undefined;
        return year ? year.name : appSettings.resources.Select_Manufacturer__Year;
    };
    //getModel
    //
    //@return {string} model
    //
    //@description
    //Gets the model of the selected vehicle
    function getModel() {
        var vehicle = customerModelService.getCurrentVehicle(),
            model = vehicle ? vehicle.getModel() : undefined;
        return model ? model.name : appSettings.resources.Select_Manufacturer__Model;
    };
    //getTransmission
    //
    //@return {string} transmission
    //
    //@description
    //Gets the transmission of the selected vehicle
    function getTransmission() {
        var vehicle = customerModelService.getCurrentVehicle(),
            transmission = vehicle ? vehicle.getTransmission() : undefined;
        return transmission ? transmission.name : appSettings.resources.Select_Manufacturer__Transmission;
    };
    //getEngine
    //
    //@return {string} engine
    //
    //@description
    //Gets the engine of the selected vehicle
    function getEngine() {
        var vehicle = customerModelService.getCurrentVehicle(),
            engine = vehicle ? vehicle.getEngine() : undefined;
        return engine ? engine.name : appSettings.resources.Select_Manufacturer__Engine;
    };
    //getDriveTrain
    //
    //@return {string} drive train
    //
    //@description
    //Gets the drive train of the selected vehicle
    function getDriveTrain() {
        var vehicle = customerModelService.getCurrentVehicle(),
            driveTrain = vehicle ? vehicle.getDriveTrain() : undefined;
        return driveTrain ? driveTrain.name : appSettings.resources.Select_Manufacturer__Drive_Train;
    };
    //getStateCaption
    //
    //@param {number} state index according to internal states array
    //
    //@return {string} current state name
    //
    //@description
    //By the client logic it is required to build caption of the state
    //according to selected value if value has not been selected just
    //return formal name
    vm.getStateCaption = function (index) {
        switch (index) {
            case 0:
                return getManufacturer();
            case 1:
                return getYear();
            case 2:
                return getModel();
            case 3:
                return getTransmission();
            case 4:
                return getEngine();
            case 5:
                return getDriveTrain();
        }
    };
    //checkSubState
    //
    //@param {number} state index to check
    //
    //@return {boolean} returns true if user selected something on this state
    //
    //@description
    //Check if user made a selection on required state. This method is using for
    //preventing state swithching untill user has not selected anything
    vm.checkSubState = function (index) {
        var vehicle = customerModelService.getCurrentVehicle();
        if (!vehicle) {
            return false;
        }
        if (index < 0) {
            return true;
        }
        switch (index) {
            case 0:
                return !!vehicle.getManufacturer();
            case 1:
                return !!vehicle.getYear();
            case 2:
                return !!vehicle.getModel();
            case 3:
                return !!vehicle.getTransmission();
            case 4:
                return !!vehicle.getEngine();
            case 5:
                return !!vehicle.getDriveTrain();
        }
    };

    $scope.setDefaultTransmission = function () {

        var vehicle = customerModelService.getCurrentVehicle();
        var model = $scope.vehicleCreationData.selectedModel || vehicle.getModel();

        return createCustomerLoader.addPromise(
            model.getTransmissions()
                .then(function (transmissions) {
                    $scope.vehicleCreationData.transmissions = transmissions;
                    vehicle.setTransmission($scope.vehicleCreationData.selectedTransmission = transmissions[0]);
                    $scope.vehicleCreationData.selectedTransmission.autoSelected = true;

                    return $scope.setDefaultEngine();
                }));
    };

    $scope.setDefaultEngine = function () {

        var vehicle = customerModelService.getCurrentVehicle();
        var transmission = $scope.vehicleCreationData.selectedTransmission || vehicle.getTransmission();

        return createCustomerLoader.addPromise(
            transmission.getEngines()
                .then(function (engines) {
                    $scope.vehicleCreationData.engines = engines;
                    vehicle.setEngine($scope.vehicleCreationData.selectedEngine = engines[0]);
                    $scope.vehicleCreationData.selectedEngine.autoSelected = true;

                    return $scope.setDefaultDriveTrain();
                }));
    };

    $scope.setDefaultDriveTrain = function () {

        var vehicle = customerModelService.getCurrentVehicle();
        var engine = $scope.vehicleCreationData.selectedEngine || vehicle.getEngine();

        return createCustomerLoader.addPromise(
            engine.getDriveTrains()
                .then(function (driveTrains) {
                    $scope.vehicleCreationData.driveTrains = driveTrains;
                    vehicle.setDriveTrain($scope.vehicleCreationData.selectedDriveTrain = driveTrains[0]);
                    $scope.vehicleCreationData.selectedDriveTrain.autoSelected = true;
                    return driveTrains[0].getVehicle();
                })
                .then(function (vehicle) {
                    return VehicleService.setVehicleDetails(vehicle);
                })
                .then(function (vehicleModel) {
                    vehicleModel.setMaintenance(vehicleModel.maintenance);
                    customerModelService.setCurrentVehicle(vehicleModel);
                })
                .catch(function (err) {
                    $log.error('Can not get vehicle object', err);
                }));
    };
    //init
    //
    //@description
    //Entry point into execution of controller client logic
    function init() {
        if ($state.params.vehicle) {
            VehicleService.setVehicleDetails($state.params.vehicle)
                .then(function (vehicleModel) {
                    vehicleModel.setMaintenance(vehicleModel.maintenance);
                    customerModelService.setCurrentVehicle(vehicleModel);
                    if ($state.params.odometer) {
                        vehicleModel.odometer = $state.params.odometer;
                        return $state.go('bookappointment.concerns');
                    } else {
                        return $state.go('overview');
                    }
                }).catch(function (err) {
                    throw new Error(err);
                });
        } else {
            $state.go(($state.current.name === 'createcustomer') ? 'createcustomer.year' : $state.current.name);
        }
    }
    //error screen vin decode options
    //
    $scope.vinDecodeOptions = {
        vinDecodeHandler: vinDecodeHandler,
        vinDecodeStart: vinDecodeStart,
        vinDecodeEnd: vinDecodeEnd,
        normalizeUrl: $scope.normalizeUrl
    };
    function vinDecodeHandler() {
        $state.go('overview');
    }
    function vinDecodeStart() {
        changeStateLoader.show('vidDecode');
    }

    function vinDecodeEnd() {
        changeStateLoader.hide('vidDecode');
    }
    // run controller client logic
    init();
    // listen to states changes to define current state index
    $scope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams) {
        vm.currentStateIndex = vm.internalStates.indexOf(toState.name);
    });
};
CreateCustomerCtrl.$inject = ['$scope', '$state', 'customerModelService', '$q', '$log', 'VehicleService', 'createCustomerLoader', 'changeStateLoader'];

function CreateCustomerLoader(LoaderService) {
    return LoaderService.getOrCreate('createCustomer');
};

CreateCustomerLoader.$inject = ['LoaderService'];

module.exports = {
    CreateCustomerCtrl: CreateCustomerCtrl,
    createCustomerLoader: CreateCustomerLoader
};

